export interface IUser {
  firstname: string;
  lastname: string;
  id: number;
  roles: Roles[];
}

export const enum Roles {
  SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ADMIN = 'ROLE_ADMIN',
  TECHNICIAN = 'ROLE_TECHNICIAN',
  FARMER = 'ROLE_FARMER',
}

export const enum RolesNames {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  TECHNICIAN = 'TECHNICIAN',
  FARMER = 'FARMER',
}
